import { ThemeUICSSObject } from '@apia/theme';
import selectEntity from './selectEntity';
/* IMPORT HERE */

const entity: ThemeUICSSObject = {
  selectEntity,
  /* PREPEND HERE */
};

export default entity;
